// extracted by css-extract-rspack-plugin
export default {"cls1":"RemovedItemNotice-cls1_z11","cls2":"RemovedItemNotice-cls2_12z RemovedItemNotice-cls1_z11"};